export const ApiResponses = {
  maintenance: 'API is currently under maintenance',
};
